import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/DatesApp.vue';
import SignPage from '@/components/SignaturePad.vue';
import ErrorPage from '@/components/ErrorPage.vue';

Vue.use(Router);

export default new Router({
    mode: 'history',  // Use history mode for clean URLs (no hash)
    routes: [
        {
            path: '/',
            name: 'Home',
            component: Home
        },

        {
            path: '/sign', // Define the route for the sign page
            name: 'SignPage',
            component: SignPage
        },
        // Add more routes as needed

        {
            path: '/error',
            name: 'ErrorPage',
            component: ErrorPage
        },

        {
            path: '/success',
            name: 'SuccessPage',
            component: () => import('@/components/SuccessPage.vue')
        }
    ]
});
